import { emptyError, ResponseType } from "../../Types/ServicesType/servicesType"
import { insuranceWisePayload } from "./type"
import api from "@services/apiList";
import instance from "@services/services";
const {reportsApi}=api

export const InsuranceWiseOutStandingReportService = async (data:insuranceWisePayload): Promise<ResponseType<any>> => {

    try {
        const result=await instance.post(reportsApi.insuranceWiseOutStanding,data)
        return result.data

    } catch (error) {
        return emptyError
    }
    
}
export const InsuranceWiseOutStandingSearchReportService = async (data:insuranceWisePayload): Promise<ResponseType<any>> => {

    try {
        const result=await instance.post(reportsApi.insuranceWiseOutStandingSearch,data)
        return result.data

    } catch (error) {
        return emptyError
    }
    
}